export const TG_URL = "https://t.me/wodota_q";
